import ModalCurrencyList from './ModalCurrencyList';

export default ModalCurrencyList;
